const validateCity = (city: string) => {
  // Check if the string is 3 or 4 characters long and all characters are digits
  if ((city.length === 3 || city.length === 4) && /^\d+$/.test(city)) {
    return false;
  }

  // If the string is not 3 or 4 digits long, or contains non-digit characters, return true
  return true;
};

export default validateCity;
